
import ko from 'rgs-knockout';

import ViewModel from './js/view-model';
import template from './templates/template.html';

ko.components.register('vehicle-maker-model-select', {
	viewModel: ViewModel,
	template: template(),
});